(() => {
  'use strict';

  const d = document;
  const w = window;
  const $ = (selector, context = d) => context.querySelector(selector);
  const $$ = (selector, context = d) => Array.from(context.querySelectorAll(selector));
  const reducedMotion = Boolean(w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches);
  const finePointer = Boolean(w.matchMedia && w.matchMedia('(hover: hover) and (pointer: fine)').matches);
  const context = (() => {
    try { return JSON.parse($('#KzfGlobalContext')?.textContent || '{}'); } catch (_) { return {}; }
  })();
  const root = String(context.root || '/').replace(/\/?$/, '/');
  const currency = context.currency || (w.Shopify?.currency?.active) || 'USD';
  const productCache = new Map();
  const normalizeBrand = (value) => String(value == null ? '' : value).replace(/Smoky Supplies/gi, 'Smokerz Supplies');
  let toastTimer;
  let returnFocus = null;
  let activeLayer = null;

  const el = (tag, className, text) => {
    const node = d.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = normalizeBrand(text);
    return node;
  };
  const read = (key, fallback) => {
    try {
      const value = JSON.parse(localStorage.getItem(key) || 'null');
      return value == null ? fallback : value;
    } catch (_) { return fallback; }
  };
  const cleanText = (html) => {
    const doc = new DOMParser().parseFromString(String(html || ''), 'text/html');
    return normalizeBrand(doc.body.textContent || '').replace(/\s+/g, ' ').trim();
  };
  const normalizeLegacyBrand = (rootNode) => {
    if (!rootNode) return;
    if (rootNode.nodeType === Node.TEXT_NODE) {
      if (/Smoky Supplies/i.test(rootNode.data)) rootNode.data = normalizeBrand(rootNode.data);
      return;
    }
    if (rootNode.nodeType !== Node.ELEMENT_NODE && rootNode !== d) return;
    const walker = d.createTreeWalker(rootNode, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/.test(parent.tagName)) return NodeFilter.FILTER_REJECT;
        return /Smoky Supplies/i.test(node.data) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    const matches = [];
    while (walker.nextNode()) matches.push(walker.currentNode);
    matches.forEach((node) => { node.data = normalizeBrand(node.data); });
    const attributeNodes = [];
    if (rootNode.matches?.('meta[content*="Smoky Supplies"],img[alt*="Smoky Supplies"],[aria-label*="Smoky Supplies"]')) attributeNodes.push(rootNode);
    attributeNodes.push(...$$('meta[content*="Smoky Supplies"],img[alt*="Smoky Supplies"],[aria-label*="Smoky Supplies"]', rootNode));
    attributeNodes.forEach((node) => ['content', 'alt', 'aria-label'].forEach((name) => {
      if (node.hasAttribute(name)) node.setAttribute(name, normalizeBrand(node.getAttribute(name)));
    }));
  };
  const formatMoney = (cents) => {
    const amount = Number(cents || 0) / 100;
    try { return new Intl.NumberFormat(d.documentElement.lang || 'en-US', { style: 'currency', currency }).format(amount); }
    catch (_) { return `$${amount.toFixed(2)}`; }
  };
  const toast = (message) => {
    const node = $('[data-kzf-toast]');
    if (!node) return;
    clearTimeout(toastTimer);
    node.textContent = message;
    node.classList.add('is-visible');
    toastTimer = setTimeout(() => node.classList.remove('is-visible'), 2800);
  };
  const focusable = (rootNode) => $$('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])', rootNode)
    .filter((node) => !node.hidden && node.offsetParent !== null);
  const lockPage = (locked) => d.documentElement.classList.toggle('kzc-no-scroll', locked);

  /* Adaptive greeting and real local browsing signals. */
  const personalize = () => {
    const greeting = $('[data-kzf-greeting]');
    const session = $('[data-kzf-session-signal]');
    const mode = $('[data-kzf-mode]');
    const delivery = $('[data-kzf-delivery-label]');
    const name = String(context.customer || '').trim();
    const hour = new Date().getHours();
    const part = hour < 12 ? 'morning' : hour < 18 ? 'afternoon' : 'evening';
    if (greeting) greeting.textContent = `Good ${part}${name ? `, ${name}` : ''}. Your catalog is ready.`;
    const recent = read('klz_recent_products_v1', []);
    const count = Array.isArray(recent) ? recent.length : 0;
    if (session) session.textContent = count ? `${count} recently viewed on this device` : 'Live catalog connected';
    if (mode) mode.textContent = count >= 3 ? 'Personalized return' : count ? 'Continue exploring' : 'Discovery';
    const preference = read('kloudz_delivery_preference_v1', 'shipping');
    const labels = { shipping: 'Ship to me ↗', lansing: 'Lansing selected ↗', belleville: 'Belleville selected ↗' };
    if (delivery) delivery.textContent = labels[preference] || 'Choose preference ↗';
  };

  /* Scroll-linked polish stays requestAnimationFrame-throttled. */
  let scrollFrame = 0;
  const updateScroll = () => {
    scrollFrame = 0;
    const progress = $('[data-kzf-scroll-progress]');
    if (progress) {
      const available = Math.max(1, d.documentElement.scrollHeight - w.innerHeight);
      progress.style.transform = `scaleX(${Math.min(1, Math.max(0, w.scrollY / available))})`;
    }
  };
  w.addEventListener('scroll', () => {
    if (!scrollFrame) scrollFrame = w.requestAnimationFrame(updateScroll);
  }, { passive: true });
  updateScroll();

  if (finePointer && !reducedMotion) {
    const glow = $('[data-kzf-cursor-glow]');
    let glowFrame = 0;
    let pointerX = 0;
    let pointerY = 0;
    d.addEventListener('pointermove', (event) => {
      pointerX = event.clientX;
      pointerY = event.clientY;
      if (!glow || glowFrame) return;
      glowFrame = w.requestAnimationFrame(() => {
        glowFrame = 0;
        glow.style.transform = `translate(${pointerX - 140}px, ${pointerY - 140}px)`;
      });
    }, { passive: true });

    $$('[data-kzf-tilt]').forEach((card) => {
      card.addEventListener('pointermove', (event) => {
        const rect = card.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - .5;
        const y = (event.clientY - rect.top) / rect.height - .5;
        card.style.transform = `perspective(800px) rotateX(${y * -4}deg) rotateY(${x * 5}deg) translateY(-3px)`;
      }, { passive: true });
      card.addEventListener('pointerleave', () => { card.style.transform = ''; });
    });
  }

  /* Reveal content progressively while keeping a no-script/design-mode fallback. */
  const revealNodes = $$('[data-kzf-home] .kzf-reveal');
  if ('IntersectionObserver' in w && !reducedMotion) {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    revealNodes.forEach((node, index) => {
      if (index < 3) node.style.transitionDelay = `${index * 70}ms`;
      revealObserver.observe(node);
    });
  } else {
    revealNodes.forEach((node) => node.classList.add('is-visible'));
  }

  /* Hero language and real product spotlight. */
  const rotatingText = $('[data-kzf-rotating-text]');
  if (rotatingText && !reducedMotion) {
    const words = String(rotatingText.dataset.words || '').split(',').map((word) => word.trim()).filter(Boolean);
    let wordIndex = 0;
    if (words.length > 1) setInterval(() => {
      wordIndex = (wordIndex + 1) % words.length;
      const animation = rotatingText.animate([
        { opacity: 1, transform: 'translateY(0)' },
        { opacity: 0, transform: 'translateY(-12px)' }
      ], { duration: 220, easing: 'ease', fill: 'forwards' });
      animation.finished.then(() => {
        rotatingText.textContent = words[wordIndex];
        rotatingText.animate([
          { opacity: 0, transform: 'translateY(12px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ], { duration: 360, easing: 'cubic-bezier(.2,.75,.2,1)', fill: 'forwards' });
      }).catch(() => {});
    }, 3400);
  }

  const spotlightRoot = $('[data-kzf-product-orbit]');
  const spotlights = $$('[data-kzf-spotlight]', spotlightRoot || d);
  let spotlightIndex = 0;
  let spotlightTimer = 0;
  const activateSpotlight = (next) => {
    if (!spotlights.length) return;
    spotlightIndex = (next + spotlights.length) % spotlights.length;
    spotlights.forEach((spotlight, index) => {
      const active = index === spotlightIndex;
      spotlight.classList.toggle('is-active', active);
      spotlight.setAttribute('aria-hidden', String(!active));
      $$('a,button', spotlight).forEach((control) => control.tabIndex = active ? 0 : -1);
    });
    const current = $('[data-kzf-spotlight-current]');
    if (current) current.textContent = String(spotlightIndex + 1).padStart(2, '0');
  };
  const startSpotlight = () => {
    clearInterval(spotlightTimer);
    if (!reducedMotion && spotlights.length > 1) spotlightTimer = setInterval(() => activateSpotlight(spotlightIndex + 1), 6200);
  };
  $('[data-kzf-spotlight-prev]', spotlightRoot || d)?.addEventListener('click', () => { activateSpotlight(spotlightIndex - 1); startSpotlight(); });
  $('[data-kzf-spotlight-next]', spotlightRoot || d)?.addEventListener('click', () => { activateSpotlight(spotlightIndex + 1); startSpotlight(); });
  spotlightRoot?.addEventListener('pointerenter', () => clearInterval(spotlightTimer));
  spotlightRoot?.addEventListener('pointerleave', startSpotlight);
  d.addEventListener('visibilitychange', () => d.hidden ? clearInterval(spotlightTimer) : startSpotlight());
  activateSpotlight(0);
  startSpotlight();

  /* Product rails support controls, native touch scrolling and optional drag. */
  const scrollRail = (id, direction) => {
    const rail = d.getElementById(id);
    if (!rail) return;
    rail.scrollBy({ left: direction * Math.max(250, rail.clientWidth * .82), behavior: reducedMotion ? 'auto' : 'smooth' });
  };
  $$('[data-kzf-rail-prev]').forEach((button) => button.addEventListener('click', () => scrollRail(button.dataset.kzfRailPrev, -1)));
  $$('[data-kzf-rail-next]').forEach((button) => button.addEventListener('click', () => scrollRail(button.dataset.kzfRailNext, 1)));
  if (finePointer) $$('[data-kzf-rail]').forEach((rail) => {
    let dragging = false;
    let origin = 0;
    let scrollOrigin = 0;
    rail.addEventListener('pointerdown', (event) => {
      if (event.target.closest('a,button,input,select')) return;
      dragging = true;
      origin = event.clientX;
      scrollOrigin = rail.scrollLeft;
      rail.setPointerCapture?.(event.pointerId);
    });
    rail.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      rail.scrollLeft = scrollOrigin - (event.clientX - origin);
    });
    ['pointerup', 'pointercancel'].forEach((name) => rail.addEventListener(name, () => { dragging = false; }));
  });

  /* Layer management: navigator and quick view share focus trapping. */
  const navigator = $('[data-kzf-navigator]');
  const quickView = $('[data-kzf-quick-view-modal]');
  const setLayer = (layer, open, trigger) => {
    if (!layer) return;
    if (open) {
      if (activeLayer && activeLayer !== layer) setLayer(activeLayer, false);
      returnFocus = trigger || d.activeElement;
      activeLayer = layer;
      layer.hidden = false;
      layer.setAttribute('aria-hidden', 'false');
      lockPage(true);
      setTimeout(() => (focusable(layer)[0] || layer).focus?.(), 25);
    } else {
      layer.hidden = true;
      layer.setAttribute('aria-hidden', 'true');
      if (activeLayer === layer) activeLayer = null;
      lockPage(Boolean(activeLayer));
      if (!activeLayer && returnFocus && d.contains(returnFocus)) setTimeout(() => returnFocus.focus(), 0);
    }
    $$('[data-kzf-navigator-open]').forEach((button) => button.setAttribute('aria-expanded', String(navigator && !navigator.hidden)));
  };
  const openNavigator = (trigger) => {
    setLayer(navigator, true, trigger);
    setTimeout(() => $('[data-kzf-navigator-input]')?.focus(), 40);
  };
  $$('[data-kzf-navigator-open]').forEach((button) => button.addEventListener('click', () => openNavigator(button)));
  $$('[data-kzf-navigator-close]').forEach((button) => button.addEventListener('click', () => setLayer(navigator, false)));
  $$('[data-kzf-quick-view-close]').forEach((button) => button.addEventListener('click', () => setLayer(quickView, false)));

  d.addEventListener('keydown', (event) => {
    const editable = event.target.matches?.('input,textarea,select,[contenteditable="true"]');
    if (event.key === '/' && !editable && !activeLayer) {
      event.preventDefault();
      openNavigator(d.activeElement);
      return;
    }
    if (event.key === 'Escape' && activeLayer) {
      event.preventDefault();
      setLayer(activeLayer, false);
      return;
    }
    if (event.key === 'Tab' && activeLayer) {
      const items = focusable(activeLayer);
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && d.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && d.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });

  /* Live catalog predictive search powers the navigator. */
  const navigatorInput = $('[data-kzf-navigator-input]');
  const navigatorStatus = $('[data-kzf-navigator-status]');
  const navigatorResults = $('[data-kzf-navigator-results]');
  let searchTimer = 0;
  let searchController = null;
  let selectedResult = -1;
  const imageUrl = (item) => {
    const image = item.image || item.featured_image;
    if (!image) return '';
    if (typeof image === 'string') return image;
    return image.url || image.src || '';
  };
  const createSearchResult = (item, kind) => {
    const link = el('a', 'kzf-navigator-result');
    link.href = item.url || `${context.search || '/search'}?q=${encodeURIComponent(item.title || '')}`;
    link.dataset.kzfNavigatorResult = '';
    const src = imageUrl(item);
    if (src) {
      const image = el('img');
      image.src = src;
      image.alt = '';
      image.loading = 'lazy';
      link.appendChild(image);
    } else {
      link.appendChild(el('span', 'kzf-result-placeholder', kind === 'Collection' ? 'C' : 'K'));
    }
    const copy = el('div');
    copy.append(el('strong', '', item.title || 'View result'));
    const detail = kind === 'Product' ? (item.price || item.vendor || item.type || 'Product') : 'Collection';
    copy.append(el('small', '', detail));
    link.append(copy, el('span', '', '↗'));
    return link;
  };
  const runNavigatorSearch = async (query) => {
    const value = String(query || '').trim();
    if (!navigatorResults || !navigatorStatus) return;
    selectedResult = -1;
    navigatorResults.replaceChildren();
    if (value.length < 2) {
      navigatorStatus.textContent = 'Type at least two characters to search the live catalog.';
      return;
    }
    searchController?.abort();
    searchController = new AbortController();
    navigatorStatus.textContent = 'Searching current products and collections…';
    try {
      const params = new URLSearchParams({
        q: value,
        'resources[type]': 'product,collection',
        'resources[limit]': '8',
        'resources[options][unavailable_products]': 'last'
      });
      const response = await fetch(`${root}search/suggest.json?${params}`, { signal: searchController.signal, headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Search unavailable');
      const payload = await response.json();
      const resources = payload?.resources?.results || {};
      const products = Array.isArray(resources.products) ? resources.products : [];
      const collections = Array.isArray(resources.collections) ? resources.collections : [];
      products.slice(0, 6).forEach((item) => navigatorResults.appendChild(createSearchResult(item, 'Product')));
      collections.slice(0, 2).forEach((item) => navigatorResults.appendChild(createSearchResult(item, 'Collection')));
      const total = products.length + collections.length;
      navigatorStatus.textContent = total ? `${total} live catalog match${total === 1 ? '' : 'es'} for “${value}”.` : `No instant matches for “${value}”. Press Search to see broader results.`;
    } catch (error) {
      if (error.name === 'AbortError') return;
      navigatorStatus.textContent = 'Instant suggestions are temporarily unavailable. Press Search for full results.';
    }
  };
  navigatorInput?.addEventListener('input', () => {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(() => runNavigatorSearch(navigatorInput.value), 180);
  });
  navigatorInput?.addEventListener('keydown', (event) => {
    const results = $$('[data-kzf-navigator-result]', navigatorResults || d);
    if (!results.length || !['ArrowDown', 'ArrowUp', 'Enter'].includes(event.key)) return;
    if (event.key === 'Enter' && selectedResult < 0) return;
    event.preventDefault();
    if (event.key === 'ArrowDown') selectedResult = (selectedResult + 1) % results.length;
    if (event.key === 'ArrowUp') selectedResult = (selectedResult - 1 + results.length) % results.length;
    if (event.key === 'Enter' && selectedResult >= 0) { results[selectedResult].click(); return; }
    results.forEach((item, index) => item.setAttribute('aria-selected', String(index === selectedResult)));
  });
  $$('[data-kzf-query]').forEach((button) => button.addEventListener('click', () => {
    if (!navigatorInput) return;
    navigatorInput.value = button.dataset.kzfQuery || '';
    navigatorInput.focus();
    runNavigatorSearch(navigatorInput.value);
  }));
  $$('[data-kzf-hero-query]').forEach((button) => button.addEventListener('click', () => {
    const input = $('[data-kzf-smart-input]');
    const form = button.closest('[data-kzf-home]')?.querySelector('[data-kzf-smart-form]');
    if (!input || !form) return;
    input.value = button.dataset.kzfHeroQuery || '';
    form.requestSubmit();
  }));

  /* Cart updates stay platform-native and appear only after success. */
  const refreshCartCount = async () => {
    try {
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      $$('.kz-market-cart-count,.cart-count-bubble,[data-cart-count]').forEach((node) => {
        if (node.matches('.cart-count-bubble') && node.firstElementChild) node.firstElementChild.textContent = String(cart.item_count);
        else node.textContent = String(cart.item_count);
      });
      d.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    } catch (_) {}
  };
  const addVariant = async (variantId, quantity, button) => {
    if (!variantId || !button) return false;
    const original = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Adding…';
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(quantity || 1) }] })
      });
      if (!response.ok) {
        const problem = await response.json().catch(() => ({}));
        throw new Error(problem.description || 'This item could not be added.');
      }
      await refreshCartCount();
      toast('Added to cart. Your cart is updated.');
      d.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      return true;
    } catch (error) {
      toast(error.message || 'This item could not be added right now.');
      return false;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = original;
    }
  };
  d.addEventListener('submit', (event) => {
    const form = event.target.closest?.('[data-kzf-ajax-add]');
    if (!form) return;
    event.preventDefault();
    const button = $('button[type="submit"]', form);
    const variant = $('input[name="id"]', form)?.value;
    const quantity = $('input[name="quantity"]', form)?.value || 1;
    addVariant(variant, quantity, button);
  });

  /* Quick view fetches authoritative product JSON and renders variants safely. */
  const renderQuickView = (product) => {
    const target = $('[data-kzf-quick-view-content]', quickView || d);
    const loading = $('[data-kzf-quick-view-loading]', quickView || d);
    if (!target || !loading) return;
    target.replaceChildren();
    const layout = el('div', 'kzf-qv-layout');
    const media = el('div', 'kzf-qv-media');
    const image = el('img');
    const imageSource = product.featured_image || product.images?.[0] || '';
    image.src = typeof imageSource === 'string' ? imageSource : (imageSource?.src || '');
    image.alt = product.title || '';
    media.appendChild(image);
    const copy = el('div', 'kzf-qv-copy');
    copy.append(el('small', '', product.vendor || product.type || 'KLOUDZ CATALOG'));
    const title = el('h2', '', product.title || 'Product');
    title.id = 'KzfQuickViewTitle';
    copy.appendChild(title);
    const variants = Array.isArray(product.variants) ? product.variants : [];
    let currentVariant = variants.find((variant) => variant.available) || variants[0] || null;
    const price = el('div', 'kzf-qv-price', formatMoney(currentVariant?.price || product.price || 0));
    const availability = el('div', 'kzf-qv-availability');
    const updateAvailability = () => {
      availability.replaceChildren();
      if (currentVariant?.available) availability.append(el('i'), d.createTextNode(' Available now'));
      else availability.textContent = 'View product for current availability';
      price.textContent = formatMoney(currentVariant?.price || product.price || 0);
    };
    updateAvailability();
    copy.append(price, availability);
    const description = cleanText(product.description);
    if (description) copy.append(el('p', 'kzf-qv-description', description));
    if (variants.length > 1) {
      const field = el('div', 'kzf-qv-field');
      const label = el('label', '', 'Choose an option');
      const select = el('select');
      label.htmlFor = 'KzfQuickVariant';
      select.id = 'KzfQuickVariant';
      variants.forEach((variant) => {
        const option = el('option', '', `${variant.title}${variant.available ? '' : ' — unavailable'}`);
        option.value = variant.id;
        option.disabled = !variant.available;
        option.selected = variant.id === currentVariant?.id;
        select.appendChild(option);
      });
      select.addEventListener('change', () => {
        currentVariant = variants.find((variant) => String(variant.id) === select.value) || currentVariant;
        updateAvailability();
        addButton.disabled = !currentVariant?.available;
      });
      field.append(label, select);
      copy.appendChild(field);
    }
    const actions = el('div', 'kzf-qv-actions');
    const addButton = el('button', 'kzf-qv-add', currentVariant?.available ? 'Add to cart' : 'Currently unavailable');
    addButton.type = 'button';
    addButton.disabled = !currentVariant?.available;
    addButton.addEventListener('click', () => addVariant(currentVariant?.id, 1, addButton));
    const shareButton = el('button', 'kzf-qv-share', '↗');
    shareButton.type = 'button';
    shareButton.setAttribute('aria-label', `Share ${product.title || 'product'}`);
    shareButton.addEventListener('click', async () => {
      const url = new URL(product.url || `${root}products/${product.handle}`, w.location.origin).href;
      try {
        if (w.navigator.share) await w.navigator.share({ title: product.title, url });
        else { await w.navigator.clipboard.writeText(url); toast('Product link copied.'); }
      } catch (_) {}
    });
    actions.append(addButton, shareButton);
    copy.appendChild(actions);
    const link = el('a', 'kzf-qv-link', 'Open full product details ↗');
    link.href = product.url || `${root}products/${product.handle}`;
    copy.appendChild(link);
    layout.append(media, copy);
    target.appendChild(layout);
    loading.hidden = true;
    target.hidden = false;
  };
  const openQuickView = async (handle, trigger) => {
    if (!quickView || !handle) return;
    const loading = $('[data-kzf-quick-view-loading]', quickView);
    const target = $('[data-kzf-quick-view-content]', quickView);
    if (loading) loading.hidden = false;
    if (target) { target.hidden = true; target.replaceChildren(); }
    setLayer(quickView, true, trigger);
    try {
      let product = productCache.get(handle);
      if (!product) {
        const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Product details unavailable');
        product = await response.json();
        productCache.set(handle, product);
      }
      renderQuickView(product);
      setTimeout(() => $('[data-kzf-quick-view-close]', quickView)?.focus(), 20);
    } catch (_) {
      if (loading) loading.hidden = true;
      if (target) {
        target.hidden = false;
        const error = el('div', 'kzf-qv-error');
        const wrap = el('div');
        wrap.append(el('strong', '', 'Quick view could not connect.'), el('p', '', 'Open the full product page to continue.'));
        const link = el('a', '', 'Open product →');
        link.href = `${root}products/${encodeURIComponent(handle)}`;
        wrap.appendChild(link);
        error.appendChild(wrap);
        target.appendChild(error);
      }
    }
  };
  d.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('[data-kzf-quick-view]');
    if (!trigger) return;
    event.preventDefault();
    openQuickView(trigger.dataset.handle, trigger);
  });

  /* Open only one FAQ answer at a time. */
  $$('.kzf-faq details').forEach((detail) => detail.addEventListener('toggle', () => {
    if (!detail.open) return;
    $$('.kzf-faq details').forEach((other) => { if (other !== detail) other.open = false; });
  }));

  /* Conservative hover prefetch improves perceived speed without bulk loading. */
  if (finePointer) {
    const prefetched = new Set();
    d.addEventListener('pointerover', (event) => {
      const link = event.target.closest?.('a[href*="/products/"],a[href*="/collections/"]');
      if (!link || prefetched.size >= 14) return;
      const url = new URL(link.href, w.location.href);
      if (url.origin !== w.location.origin || prefetched.has(url.href)) return;
      prefetched.add(url.href);
      const hint = el('link');
      hint.rel = 'prefetch';
      hint.href = url.href;
      d.head.appendChild(hint);
    }, { passive: true });
  }

  normalizeLegacyBrand(d.documentElement);
  const brandObserver = new MutationObserver((records) => records.forEach((record) => record.addedNodes.forEach(normalizeLegacyBrand)));
  if (d.body) brandObserver.observe(d.body, { childList: true, subtree: true });
  w.addEventListener('pageshow', personalize);
  d.addEventListener('shopify:section:load', personalize);
  d.addEventListener('click', (event) => {
    if (event.target.closest?.('[data-kzc-location-value]')) setTimeout(personalize, 80);
  });
  personalize();
  d.documentElement.classList.add('kzf-ready');
})();
